import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found text-center mt-5">
            <h1>404 not found</h1>
        </div >
    );
};

export default NotFound;